import api from '@/api/ai'

const state = {

}

const actions = {
  createAISummary (context, params) {
    return api.createAISummary(params)
  },
  updateAISummary (context, params) {
    return api.updateAISummary(params)
  },
  getAISummaryInfoByTaskId (context, taskId) {
    return api.getAISummaryInfoByTaskId(taskId)
  },
  createAIResumeMatch (context, params) {
    return api.createAIResumeMatch(params)
  },
  getAIMatchInfoByTaskId (context, taskId) {
    return api.getAIMatchInfoByTaskId(taskId)
  },
  createAIComparison (context, params) {
    return api.createAIComparison(params)
  },
  getAIComparisonInfoByTaskId (context, taskId) {
    return api.getAIComparisonInfoByTaskId(taskId)
  },
  getAIComparisonHistory (context, params) {
    return api.getAIComparisonHistory(params)
  },
  getAIComparisonHistoryInfoById (context, historyId) {
    return api.getAIComparisonHistoryInfoById(historyId)
  },
  getAIAgentList (context, params) {
    return api.getAIAgentList(params)
  },
  getAIAgentInfoById (context, agentId) {
    return api.getAIAgentInfoById(agentId)
  },
  getAIModelList (context) {
    return api.getAIModelList()
  },
  updateAIAgent (context, data) {
    return api.updateAIAgent(data)
  }
}

const mutations = {
}

const getters = {
}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
